import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import RenunciaReceitaService from '../../../../services/renunciaReceita-auth';



const Renuncia = () => {
    const [nome, setNome] = useState("");
    const [valor, setValor] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [vigencia, setVigencia] = useState("");
    const [setor, setSetor] = useState("");
    const [especie, setEspecie] = useState("");
    const [produto, setProduto] = useState("");
    const [contrapartida, setContrapartida] = useState("");
    const [impacto, setImpacto] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const local = await RenunciaReceitaService.cadastro({
                nome: nome,
                valor: valor,
                cnpj: cnpj,
                vigencia: vigencia,
                setor: setor,
                especie: especie,
                produto: produto,
                contrapartida: contrapartida,
                impacto: impacto
            })
            if (local.data["_id"]) {
                alert("Renúncia de Receita cadastrada com sucesso!")
                setSucesso(true);
            }
            else {
                alert(local.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("");
        setValor("");
        setCnpj("");
        setSetor("");
        setEspecie("");
        setVigencia("");
        setProduto("");
        setContrapartida("");
        setImpacto("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="cnpj">
                                <FloatingLabel
                                    label="CNPJ"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="cnpj"
                                        value={cnpj}
                                        onChange={e => setCnpj(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Valor Captado">
                                <FloatingLabel
                                    label="Valor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Vigência">
                                <FloatingLabel
                                    label="Vigência"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="vigencia"
                                        value={vigencia}
                                        onChange={e => setVigencia(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Setor">
                                <FloatingLabel
                                    label="Setor"
                                    className="mb-3"
                                >
                                     <Form.Control
                                        required
                                        type="text"
                                        name="setor"
                                        value={setor}
                                        onChange={e => setSetor(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="especie">
                                <FloatingLabel
                                    label="Espécie do Benefício"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="especie"
                                        value={especie}
                                        onChange={e => setEspecie(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Produto">
                                <FloatingLabel
                                    label="Produto"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="produto"
                                        value={produto}
                                        onChange={e => setProduto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Contrapartida">
                                <FloatingLabel
                                    label="Contrapartida"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="contrapartida"
                                        value={contrapartida}
                                        onChange={e => setContrapartida(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Impacto Obtido/Esperado">
                                <FloatingLabel
                                    label="Impacto Obtido/Esperado"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="impacto"
                                        value={impacto}
                                        onChange={e => setImpacto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>

                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/renuncias/renunciareceita'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Renúncia de Receita cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/renuncias/renunciareceita/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Renúncias de Receitas
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/renuncias/renunciareceita'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Renuncia;